import React from 'react';
export function WhatYouGet() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4 pt-[10px] pb-[10px]" data-id="element-307">
      <div className="max-w-5xl mx-auto" data-id="element-308">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-12" data-id="element-309">
          Lo que <span className="text-[#FF6B00]" data-id="element-310">recibís</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-311">
          {/* Primaria */}
          <div className="bg-black border border-[#FF6B00]/30 rounded-2xl p-6" data-id="element-312">
            <h3 className="text-[#FF6B00] text-xl font-black mb-2" data-id="element-313">
              📘 PRIMARIA — 6 Tomos
            </h3>
            <p className="text-gray-400 text-sm mb-5" data-id="element-314">
              Para docentes de Inglés de 1° a 6° grado
            </p>
            <div className="space-y-3" data-id="element-315">
              <div className="flex items-center gap-3 text-white" data-id="element-316">
                <span className="text-xl" data-id="element-317">📘</span>
                <div className="flex-1" data-id="element-318">
                  <span className="font-bold" data-id="element-319">Tomo 1 — 1° Grado:</span>
                  <span className="text-gray-300" data-id="element-320"> The World Around Me</span>
                </div>
                <span className="bg-[#FF6B00]/20 text-[#FF6B00] text-xs font-bold px-2 py-1 rounded-full border border-[#FF6B00]/40" data-id="element-321">
                  Pre-A1
                </span>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-322">
                <span className="text-xl" data-id="element-323">📗</span>
                <div className="flex-1" data-id="element-324">
                  <span className="font-bold" data-id="element-325">Tomo 2 — 2° Grado:</span>
                  <span className="text-gray-300" data-id="element-326"> My Daily Life</span>
                </div>
                <span className="bg-[#FF6B00]/20 text-[#FF6B00] text-xs font-bold px-2 py-1 rounded-full border border-[#FF6B00]/40" data-id="element-327">
                  A1
                </span>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-328">
                <span className="text-xl" data-id="element-329">📙</span>
                <div className="flex-1" data-id="element-330">
                  <span className="font-bold" data-id="element-331">Tomo 3 — 3° Grado:</span>
                  <span className="text-gray-300" data-id="element-332"> Animals & Actions</span>
                </div>
                <span className="bg-[#FF6B00]/20 text-[#FF6B00] text-xs font-bold px-2 py-1 rounded-full border border-[#FF6B00]/40" data-id="element-333">
                  A1
                </span>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-334">
                <span className="text-xl" data-id="element-335">📕</span>
                <div className="flex-1" data-id="element-336">
                  <span className="font-bold" data-id="element-337">Tomo 4 — 4° Grado:</span>
                  <span className="text-gray-300" data-id="element-338"> Routines & Places</span>
                </div>
                <span className="bg-[#FF6B00]/20 text-[#FF6B00] text-xs font-bold px-2 py-1 rounded-full border border-[#FF6B00]/40" data-id="element-339">
                  A1-A2
                </span>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-340">
                <span className="text-xl" data-id="element-341">📓</span>
                <div className="flex-1" data-id="element-342">
                  <span className="font-bold" data-id="element-343">Tomo 5 — 5° Grado:</span>
                  <span className="text-gray-300" data-id="element-344"> My Community</span>
                </div>
                <span className="bg-[#FF6B00]/20 text-[#FF6B00] text-xs font-bold px-2 py-1 rounded-full border border-[#FF6B00]/40" data-id="element-345">
                  A2
                </span>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-346">
                <span className="text-xl" data-id="element-347">📔</span>
                <div className="flex-1" data-id="element-348">
                  <span className="font-bold" data-id="element-349">Tomo 6 — 6°/7° Grado:</span>
                  <span className="text-gray-300" data-id="element-350"> The Modern World</span>
                </div>
                <span className="bg-[#FF6B00]/20 text-[#FF6B00] text-xs font-bold px-2 py-1 rounded-full border border-[#FF6B00]/40" data-id="element-351">
                  A2
                </span>
              </div>
            </div>
          </div>

          {/* Secundaria */}
          <div className="bg-black border border-[#FF6B00]/30 rounded-2xl p-6" data-id="element-352">
            <h3 className="text-[#FF6B00] text-xl font-black mb-2" data-id="element-353">
              📗 SECUNDARIA — 6 Tomos
            </h3>
            <p className="text-gray-400 text-sm mb-5" data-id="element-354">
              Para docentes de Inglés de 1° a 6° año
            </p>
            <div className="space-y-3" data-id="element-355">
              <div className="flex items-center gap-3 text-white" data-id="element-356">
                <span className="text-xl" data-id="element-357">📘</span>
                <div className="flex-1" data-id="element-358">
                  <span className="font-bold" data-id="element-359">Tomo 1 — 1° Año:</span>
                  <span className="text-gray-300" data-id="element-360"> Welcome to Secondary</span>
                </div>
                <span className="bg-[#FF6B00]/20 text-[#FF6B00] text-xs font-bold px-2 py-1 rounded-full border border-[#FF6B00]/40" data-id="element-361">
                  A2-B1
                </span>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-362">
                <span className="text-xl" data-id="element-363">📗</span>
                <div className="flex-1" data-id="element-364">
                  <span className="font-bold" data-id="element-365">Tomo 2 — 2° Año:</span>
                  <span className="text-gray-300" data-id="element-366"> The World We Live In</span>
                </div>
                <span className="bg-[#FF6B00]/20 text-[#FF6B00] text-xs font-bold px-2 py-1 rounded-full border border-[#FF6B00]/40" data-id="element-367">
                  B1
                </span>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-368">
                <span className="text-xl" data-id="element-369">📙</span>
                <div className="flex-1" data-id="element-370">
                  <span className="font-bold" data-id="element-371">Tomo 3 — 3° Año:</span>
                  <span className="text-gray-300" data-id="element-372"> Connecting Worlds</span>
                </div>
                <span className="bg-[#FF6B00]/20 text-[#FF6B00] text-xs font-bold px-2 py-1 rounded-full border border-[#FF6B00]/40" data-id="element-373">
                  B1-B2
                </span>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-374">
                <span className="text-xl" data-id="element-375">📕</span>
                <div className="flex-1" data-id="element-376">
                  <span className="font-bold" data-id="element-377">Tomo 4 — 4° Año:</span>
                  <span className="text-gray-300" data-id="element-378"> Global Challenges</span>
                </div>
                <span className="bg-[#FF6B00]/20 text-[#FF6B00] text-xs font-bold px-2 py-1 rounded-full border border-[#FF6B00]/40" data-id="element-379">
                  B2
                </span>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-380">
                <span className="text-xl" data-id="element-381">📓</span>
                <div className="flex-1" data-id="element-382">
                  <span className="font-bold" data-id="element-383">Tomo 5 — 5° Año:</span>
                  <span className="text-gray-300" data-id="element-384"> Language & Society</span>
                </div>
                <span className="bg-[#FF6B00]/20 text-[#FF6B00] text-xs font-bold px-2 py-1 rounded-full border border-[#FF6B00]/40" data-id="element-385">
                  B2-C1
                </span>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-386">
                <span className="text-xl" data-id="element-387">📔</span>
                <div className="flex-1" data-id="element-388">
                  <span className="font-bold" data-id="element-389">Tomo 6 — 6° Año:</span>
                  <span className="text-gray-300" data-id="element-390"> Into the Future</span>
                </div>
                <span className="bg-[#FF6B00]/20 text-[#FF6B00] text-xs font-bold px-2 py-1 rounded-full border border-[#FF6B00]/40" data-id="element-391">
                  C1
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* What each tome includes */}
        <div className="bg-[#FF6B00]/5 border border-[#FF6B00]/30 rounded-2xl p-8 text-center" data-id="element-392">
          <h3 className="text-[#FF6B00] text-xl font-black mb-6" data-id="element-393">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-2xl mx-auto" data-id="element-394">
            <div className="flex items-start gap-2 text-left" data-id="element-395">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-396">✅</span>
              <span className="text-white text-sm" data-id="element-397">
                Planificación anual lista para presentar al directivo
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-398">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-399">✅</span>
              <span className="text-white text-sm" data-id="element-400">
                4 unidades didácticas completas con todas las clases del año
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-401">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-402">✅</span>
              <span className="text-white text-sm" data-id="element-403">
                Secuencias didácticas paso a paso con inicio–desarrollo–cierre
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-404">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-405">✅</span>
              <span className="text-white text-sm" data-id="element-406">
                Actividades listas para imprimir y usar en el aula
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-407">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-408">✅</span>
              <span className="text-white text-sm" data-id="element-409">
                Evaluación diagnóstica + 3 evaluaciones trimestrales
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-410">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-411">✅</span>
              <span className="text-white text-sm font-bold" data-id="element-412">
                SOLUCIONARIO COMPLETO con todas las respuestas correctas
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-413">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-414">✅</span>
              <span className="text-white text-sm" data-id="element-415">
                Rúbricas de evaluación oral y escrita
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-416">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-417">✅</span>
              <span className="text-white text-sm" data-id="element-418">
                Autoevaluación del alumno incluida
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-419">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-420">✅</span>
              <span className="text-white text-sm" data-id="element-421">
                Portfolio sugerido por unidad
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-422">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-423">✅</span>
              <span className="text-white text-sm" data-id="element-424">
                100% alineado a NAP Argentina y Diseños Curriculares
                provinciales
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-425">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-426">✅</span>
              <span className="text-white text-sm" data-id="element-427">
                Bibliografía oficial al finalizar cada tomo
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}